/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:90fdc1ad-ecf7-49a9-9b54-2f489a1b9d69",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_9WHhGaGCV",
    "aws_user_pools_web_client_id": "612fs3f3h8k56q4j070sgnlaod",
    "oauth": {},
    "aws_user_files_s3_bucket": "xenkias3bucket202528-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
